import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CustomerEntry from "@/pages/CustomerEntry";
import Workspace from "@/pages/Workspace";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { getCustomer, getAdminToken } from "@/lib/api";

const ProtectedCustomer = ({ children }) => {
  return getCustomer() ? children : <Navigate to="/" replace />;
};

const ProtectedAdmin = ({ children }) => {
  return getAdminToken() ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  useEffect(() => {
    document.title = "PRAMID — Toplu Fiyatlandırma Portalı";
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CustomerEntry />} />
          <Route
            path="/workspace"
            element={
              <ProtectedCustomer>
                <Workspace />
              </ProtectedCustomer>
            }
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedAdmin>
                <AdminDashboard />
              </ProtectedAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
